import { type UseQueryResult, useQuery } from 'react-query';
import {
  BrokerFixChannelSettingsService,
  Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto,
} from '@wealthlane/api-services/wealthlane-award-settlement-service';

type UseGetFixConfigByIdOptions = {
  enabled?: boolean;
};

const useGetFixConfigById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId: string,
  options?: UseGetFixConfigByIdOptions
): UseQueryResult<Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_BrokerFixChannelSettingsDto> => {
  const enabled = (options?.enabled ?? true) && Boolean(companyId);

  return useQuery(
    ['getFixConfigByBrokerCompany', companyId],
    async () => {
      return await handleRequest(
        BrokerFixChannelSettingsService.getApiAwardSettlementApiAppBrokerFixChannelSettingsByBrokerCompany(
          companyId
        )
      );
    },
    { enabled }
  );
};

export default useGetFixConfigById;
